// Must include a trailing slash. In dev, default to a local Django server; set REACT_APP_BACKEND_URL to override.
function resolveBackendUrl() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (fromEnv && String(fromEnv).trim() !== "") {
    const u = String(fromEnv).trim();
    return u.endsWith("/") ? u : `${u}/`;
  }
  if (process.env.NODE_ENV === "development") {
    return "http://127.0.0.1:8000/";
  }
  return "https://backend.gimmethedog.com/";
}

export const URL = resolveBackendUrl();